import React, { Component } from 'react';
import { NavLink, Navigate } from 'react-router-dom';

import { styled } from '@mui/system';
import { Redirect } from 'react-router-dom';
import Button from '@mui/material/Button';
import axios from 'axios';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import PropTypes from 'prop-types';
import TablePagination from '@mui/material/TablePagination';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import TextField from '@mui/material/TextField';
import BusinessIcon from '@mui/icons-material/Business';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import Columnsettings from './Columnsettings';
import logoImage from './images/logo.jpg';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Select from '@mui/material/Select';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import psdfimage from './images/psdfimage.png';


function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}


const headCells = [

    { id: 'TransactionDate', numeric: false, label: 'Date' },
    { id: 'Customer', numeric: false, label: 'Customer Name' },
    { id: 'number', numeric: false, label: 'Number' },
    { id: 'Net_Amount', numeric: false, label: 'Net' },
    { id: 'Cost_Price', numeric: false, label: 'Cost' },
    { id: 'Profit_Value', numeric: false, label: '' },
    { id: 'Profit_Percentage', numeric: false, label: 'Profit(%)' },
];

const headCellsdetailes = [

    { id: 'TransactionDate', numeric: false, label: 'Date' },
    { id: 'Customer', numeric: false, label: 'Customer Name' },
    { id: 'number', numeric: false, label: 'Number' },
    { id: 'quantity', numeric: false, label: 'Qnty/Hrs' },
    { id: 'Net_Amount', numeric: false, label: 'Net' },
    { id: 'Cost_Price', numeric: false, label: 'Cost' },
    { id: 'Profit_Value', numeric: false, label: '' },
    { id: 'Profit_Percentage', numeric: false, label: 'Profit(%)' },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, isDetailedReport } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    const currentHeadCells = isDetailedReport ? headCellsdetailes : headCells;

    return (
        <TableHead>
            <TableRow>
                {currentHeadCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={useStyles.visuallyHidden}>
                                    {order === 'desc' ? ' ' : ' '}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object, 
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    isDetailedReport: PropTypes.bool.isRequired, 
};

const useToolbarStyles = styled(theme => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
    },
}));

const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const { numSelected } = props;
    return null; 
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const useStyles = styled(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    form: {
        width: '500%',
        marginTop: theme.spacing(1),
        minWidth: 120,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));


export default class Profitanalysisreport extends Component {
    constructor(props) {
        super();

        var strdob = new Date();
        var month = "";

        if ((strdob.getMonth() + 1) < 10) {
            month = "0" + (strdob.getMonth() + 1);
        } else {
            month = (strdob.getMonth() + 1);
        }

        const currentDate = new Date();

        var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
        var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();


        this.state = {
            logredirect: false, pagename: '', page: 0, prevpage: 0, totaldata: 0, rowsPerPage: 20, rowsPaging: [],
            search: '', id: '', order: 'desc', orderBy: 'TransactionDate', compdata: [], isblock: '', name: '',
            compemail: '', btndisabled: false,
            submitbtn: "Submit", todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: dayjs(lastDayOfMonth),
            fromdate: dayjs(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)),
            openExportDialog: false,
            fromdate1: currentDate.getFullYear() + '-' + month1 + '-' + '01', isselectdisplay: false, type: 0, report: '1',
            fromDateEnabled: false, detaileddata: [], 
            toDateEnabled: false,
        };
    }

    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({ [nam]: val });
    }

    componentWillMount() {
        document.title = "Isifol - Profit Analysis Report";
      	  if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
 this.fetchReportData(this.state.page, this.state.rowsPerPage);	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
        this.props.parentdasCallback(
            "Profit Analysis Report~"
        );
      
    }
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=33')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
    this.fetchReportData(this.state.page, this.state.rowsPerPage);
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
    componentDidUpdate(prevProps, prevState) {
        if (prevState.report !== this.state.report ||
            prevState.fromdate1 !== this.state.fromdate1 ||
            prevState.todate1 !== this.state.todate1 ||
            prevState.name !== this.state.name ||
            prevState.type !== this.state.type ||
            prevState.page !== this.state.page ||
            prevState.rowsPerPage !== this.state.rowsPerPage
        ) {
            this.fetchReportData(this.state.page, this.state.rowsPerPage);
        }
    }

    fetchReportData = async (page, rowsPerPage) => {
        const { report, name, type, fromdate1, todate1 } = this.state;
        const detailedReportParam = report === '2' ? 1 : 0;

        let apiUrl = '';
        if (report === '1') { 
            apiUrl = localStorage.getItem("ISIurl") + 'ajaxreports.php?action=profitanalysisreportgetall&cu_businessname=' + name + '&type=' + type + '&fromdate=' + fromdate1 + '&todate=' + todate1 + '&StartIndex=' + page + '&PageSize=' + rowsPerPage + '&detailedReport=' + detailedReportParam+'&cmp_id='+localStorage.getItem('ISIcmpid');
        } else { 
            apiUrl = localStorage.getItem("ISIurl") + 'ajaxreports.php?action=profitanalysissummaryreportgetalls&cu_businessname=' + name + '&type=' + type + '&fromdate=' + fromdate1 + '&todate=' + todate1;
        }

        try {
            const resp = await axios.get(apiUrl);
            if (resp.data.length > 0) {
               

              
                    this.setState({
                        compdata: resp.data,
                        totaldata: parseInt(resp.data[0].count),
                        detaileddata: [] 
                    });
                
            } else {
                this.setState({ compdata: [], detaileddata: [], totaldata: 0 });
            }
        } catch (error) {
            console.error("Error fetching profit analysis report:", error);
            this.setState({ compdata: [], detaileddata: [], totaldata: 0 });
        }
    };


  

    CloseMoreoption = () => {
        this.setState({ isselectdisplay: false });
    }

    handleClickSearch = () => {
        this.fetchReportData(this.state.page, this.state.rowsPerPage);
    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({
            orderBy: property,
            order: isAsc ? 'desc' : 'asc'
        });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            page: newPage,
            rowsPerPage: this.state.rowsPerPage
        });
    };

    Handleclickviewmore = () => {
        this.setState({ isselectdisplay: true });
    }

    handleChangeRowsPerPage = event => {
        let pageval = event.target.value;
        this.setState({
            page: 0,
            rowsPerPage: parseInt(pageval),
            prevpage: -1
        }); 
    };

    fromdatehandler = (date) => {
        if (date) {
            this.setState({
                fromdate: date,
                fromdate1: date.format('YYYY-MM-DD'),
                fromDateEnabled: true
            });
        }
    };

    todatehandler = (date) => {
        if (date) {
            this.setState({
                todate: date,
                todate1: date.format('YYYY-MM-DD'),
                toDateEnabled: true
            });
        }
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClickOpen = () => {
        this.setState({
            open: !this.state.open,
        });
    };

    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };

    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };

handleDownload = () => {
    const { compdata, detaileddata, report } = this.state;
    const doc = new jsPDF();

    const imgWidth = 40;
    const imgHeight = 12;
    const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
    const imgY = 10;
    doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);

    const title = 'Profit Analysis Report';
    doc.setFontSize(16);
    const titleY = imgY + imgHeight + 8;
    doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
    const tableStartY = titleY + 10;

    let headers = [];
    let rows = [];

    
        headers = [['Date', 'Name', 'Number', 'Net', 'Cost', 'Profit Value', 'Profit(%)']];
        rows = compdata.map(item => {
            return [
                item.TransactionDate,
                item.Customer,
                item.number,
                parseFloat(item.Net_Amount || 0).toFixed(2),
                parseFloat(item.Cost_Price || 0).toFixed(2),
                parseFloat(item.Profit_Value || 0).toFixed(2),
                (item.Profit_Margin_Percentage ? item.Profit_Margin_Percentage + '%' : '0.00%')
            ];
        });
    

    doc.autoTable({
        head: headers,
        body: rows,
        startY: tableStartY,
        theme: 'striped',
        didDrawPage: function (data) {
            var str = "Page " + doc.internal.getNumberOfPages();
            doc.setFontSize(10);
            doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
        }
    });

    doc.save('Profitanalysisreport.pdf');
};
    onchangedateHandler = (event) => {
        let selectedOption = event.target.value;
        const periodMap = {
            'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
            'This Quarter': [dayjs().startOf('quarter'), dayjs().endOf('quarter')],
            'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
            'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
            'Last Quarter': [dayjs().subtract(1, 'quarter').startOf('quarter'), dayjs().subtract(1, 'quarter').endOf('quarter')],
            'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
            'This Financial Year': [dayjs().month() >= 3 ? dayjs().startOf('year').month(3) : dayjs().subtract(1, 'year').month(3), dayjs().month() >= 3 ? dayjs().endOf('year').month(2).add(1, 'year') : dayjs().startOf('year').month(2)],
            'Last Financial Year': [dayjs().month() >= 3 ? dayjs().subtract(1, 'year').month(3) : dayjs().subtract(2, 'year').month(3), dayjs().month() >= 3 ? dayjs().startOf('year').month(2) : dayjs().subtract(1, 'year').month(2)],
            'Custom': [dayjs(), dayjs().endOf('month')]
        };

        if (selectedOption === 'Custom') {
            this.setState({
                fromdate: periodMap['Custom'][0],
                todate: periodMap['Custom'][1],
                fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
                todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
                fromDateEnabled: true,
                toDateEnabled: true
            });
        } else {
            this.setState({
                fromdate: periodMap[selectedOption][0],
                todate: periodMap[selectedOption][1],
                fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
                todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
                fromDateEnabled: false,
                toDateEnabled: false
            });
        }
    };

  groupDataByCustomer = (data) => {
    const grouped = {};
    data.forEach(item => {
        const customerName = item.Customer;
        const invoiceNumber = item.number;

        if (!grouped[customerName]) {
            grouped[customerName] = {}; 
        }

        if (!grouped[customerName][invoiceNumber]) {
            grouped[customerName][invoiceNumber] = [];
        }
        grouped[customerName][invoiceNumber].push(item);
    });
    return grouped;
};

    render() {
        if (this.state.redirect === true) {
            return <Navigate to={this.state.pagename} />;
        }
        const { compdata, order, orderBy, page, rowsPerPage, totaldata, report, detaileddata } = this.state;

        const isDetailedReport = report === '2';
		let url = '#';

        return (
            <React.Fragment>
                <div className="searchbox">
                    <ul>
                        <li>
                            <p>Search</p>
                            <p>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    className="txtbox"
                                    value={this.state.name}
                                    id="name"
                                    inputProps={{ tabIndex: "1", maxLength: 150 }}
                                    name="name"
                                    onChange={this.myChangeHandler}
                                    InputProps={{
                                        endAdornment: (
                                            <SearchOutlinedIcon style={{ marginLeft: 8 }} />
                                        ),
                                    }}
                                />
                            </p>
                        </li>

                        <li>
                            <p>Period</p>
                            <p>
                                <Select
                                    native
                                    variant="outlined" className="txtbox"
                                    margin="normal"
                                    fullWidth
                                    onChange={this.onchangedateHandler}
                                    inputProps={{ tabIndex: "4" }}
                                >
                                    <option>This Month</option>
                                    <option>This Quarter</option>
                                    <option>This Year</option>
                                    <option>Last Month</option>
                                    <option>Last Quarter</option>
                                    <option>Last Year</option>
                                    <option>This Financial Year</option>
                                    <option>Last Financial Year</option>
                                    <option>Custom</option>
                                </Select>
                            </p>
                        </li>

                        <li>
                            <p>From Date</p>
                            <p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={!this.state.fromDateEnabled}
                                            value={this.state.fromdate}
                                            className="txtbox"
                                            onChange={this.fromdatehandler}
                                            format="MM/DD/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </p>
                        </li>

                        <li>
                            <p>To Date</p>
                            <p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            disabled={!this.state.toDateEnabled}
                                            value={this.state.todate}
                                            className="txtbox"
                                            onChange={this.todatehandler}
                                            format="MM/DD/YYYY"
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </p>
                        </li>

                        <li>
                            <p>&nbsp;</p>
                            <p>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    className="morebtn"
                                    onClick={this.Handleclickviewmore}
                                >
                                    More
                                </Button>
                                <span className="closeincon">
                                    {this.state.isselectdisplay === true && (
                                        <CloseRoundedIcon onClick={this.CloseMoreoption} />
                                    )}
                                </span>
                            </p>
                        </li>

                        <li>
                            <p>&nbsp;</p>
                            <p className="searchbutton">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    className="frmSecondarybtn"
                                    onClick={this.handleClickSearch}
                                >
                                    Calculate
                                </Button>
                                &nbsp;
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="exportbtn"
                                    onClick={this.handleOpenExportDialog}
                                >
                                    EXPORT
                                </Button>
                            </p>
                        </li>

                        {this.state.isselectdisplay === true && (
                            <>
                                <li>
                                    <p>Type</p>
                                    <p>
                                        <Select
                                            native
                                            variant="outlined"
                                            className="txtbox"
                                            margin="normal"
                                            fullWidth
                                            onChange={this.myChangeHandler}
                                            id="type"
                                            value={this.state.type}
                                            name="type"
                                            inputProps={{ tabIndex: "4" }}
                                        >
                                            <option value={0}>All</option>
                                            <option value={1}>Invoices  </option>
											 <option value={2}>Credit Notes</option>
                                            <option value={3}>Estimates</option>
                                        </Select>
                                    </p>
                                </li>

                                <li>
                                    <p>Show Details</p>
                                    <p>
                                        <Select
                                            native
                                            variant="outlined"
                                            className="txtbox"
                                            margin="normal"
                                            fullWidth
                                            onChange={this.myChangeHandler}
                                            id="report"
                                            value={this.state.report}
                                            name="report"
                                            inputProps={{ tabIndex: "4" }}
                                        >
                                            <option value={'1'}>Summary Report</option>
                                            <option value={'2'}>Detailed Report</option>
                                        </Select>
                                    </p>
                                </li>
                            </>
                        )}
                    </ul>
                </div>

                <div className="clear"></div>
            

                <Paper>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table" id="salesbook">
                            <EnhancedTableHead
                                order={this.state.order}
                                orderBy={this.state.orderBy}
                                onRequestSort={this.handleRequestSort}
                                rowCount={isDetailedReport ? Object.keys(detaileddata).length : compdata.length} // Adjust rowCount for detailed report
                                isDetailedReport={isDetailedReport}
                            />

                            <TableBody>
                                {totaldata === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={isDetailedReport ? headCellsdetailes.length : headCells.length} align="center">
                                            <h3>No Records</h3>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    isDetailedReport ? (
    Object.keys(detaileddata).map((customerName) => (
        <React.Fragment key={customerName}>
            <TableRow>
                <TableCell colSpan={headCellsdetailes.length} style={{ fontWeight: 'bold', backgroundColor: '#e0e0e0' }}>
                    Customer: {customerName}
                </TableCell>
            </TableRow>
            {Object.keys(detaileddata[customerName]).map((invoiceNumber) => {
                const invoiceItems = detaileddata[customerName][invoiceNumber];
                
                let totalNetAmount = 0;
                let totalCostPrice = 0;
                let totalProfitValue = 0;

                invoiceItems.forEach(item => {
                    totalNetAmount += parseFloat(item.Net_Amount || 0);
                    totalCostPrice += parseFloat(item.Cost_Price || 0);
                    totalProfitValue += parseFloat(item.Profit_Margin_Percentage || 0);
                });

                const subtotalProfitPercentage = this.calculateProfitPercentage(totalNetAmount, totalCostPrice);

                return (
                    <React.Fragment key={`${customerName}-${invoiceNumber}`}>
                        {stableSort(invoiceItems, getSorting(order, orderBy)).map((item, itemIndex) => (
                            <TableRow key={`${customerName}-${invoiceNumber}-${item.TransactionId}-${itemIndex}`}>
                             
								<TableCell>{item.TransactionDate}</TableCell>
                                <TableCell>{item.Customer}</TableCell>
                                <TableCell>{item.number}</TableCell>
                                <TableCell>{item.quantity}</TableCell>
                                <TableCell>{item.Net_Amount}</TableCell>
                                <TableCell>{item.Cost_Price}</TableCell>
                                <TableCell>{item.Profit_Value}</TableCell>
                                <TableCell>
                                    {item.Profit_Percentage}
                                    {item.Profit_Percentage ? '%' : ''}
                                </TableCell>
                            </TableRow>
                        ))}
                        
                        <TableRow style={{ fontWeight: 'bold' }}>
						<TableCell> </TableCell>
						<TableCell> </TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>{invoiceNumber}</TableCell>
                           <TableCell> </TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>{totalNetAmount.toFixed(2)}</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>{totalCostPrice.toFixed(2)}</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>{totalProfitValue.toFixed(2)}</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>{subtotalProfitPercentage.toFixed(2)}%</TableCell>
                        </TableRow>
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    ))
) : (
                                      stableSort(compdata, getSorting(order, orderBy)).map((item, index) => {
										
											let url = '#'; 
											if (item.TransactionType === "1") {
												url = `#/Salesinvoiceviewmore?sinoid=${item.id}`;
											} else if (item.TransactionType === "3") {
												url = `#/Estimateviewmore?seoid=${item.id}`;
											} else if (item.TransactionType === "2") {
												url = `#/Salecreditnoteviewmore?scnoid=${item.id}`;
											}

											
											return (
												<TableRow
													key={index}
													component="a"
													href={url}
													style={{ cursor: 'pointer', textDecoration: 'none' }}
												>
													
													<TableCell>{item.TransactionDate}</TableCell>
													<TableCell>{item.Customer}</TableCell>
													<TableCell>{item.number}</TableCell>
													<TableCell>{item.Net_Amount}</TableCell>
													<TableCell>{item.Cost_Price}</TableCell>
													<TableCell>{item.Profit_Value}</TableCell>
													<TableCell>
														{item.Profit_Margin_Percentage}
														{item.Profit_Margin_Percentage ? '%' : ''}
													</TableCell>
												</TableRow>
											);
										})

										
										
										
										
										
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[50, 100, 200, 300, 400]}
                        component="div"
                        count={this.state.totaldata}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </Paper>

                <Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Generated Detailed Trial Balance report</DialogTitle>

                    <DialogContent>
                        <p> To generate a new report, based on the latest selection criteria you've specified, choose the format
                            you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>

<p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
                        <ReactHTMLTableToExcel
                            variant="contained"
                            color="primary"
                            id="test-table-xls-button"
                            className="my-custom-excel-button"
                            table="salesbook"
                            filename="Profit Analysis Report" 
                            sheet="Profit Analysis Report" 
                            buttonText="EXPORT to Excel" 

                        />
                         <img
    src={psdfimage}
    width={100}
    height={100}
    style={{ cursor: "pointer" }}
    onClick={this.handleDownload}
    alt="Download PDF"
  /></p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseExportDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>


            </React.Fragment>

        );
    }

}
 export class fromtodate extends Component {
  constructor(props) {
    super(props);
    this.state = {
		   fromdate: props.fromdate || new Date(),
      todate: props.todate || new Date(),
      fromdate1: props.fromdate1 || '',
      todate1: props.todate1 || '',
    };
  }

onchangedateHandler = (event) => {
  let selectedOption = event.target.value;
  const periodMap = {
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
   'This Quarter': [dayjs().startOf('month'), dayjs().endOf('month').add(3, 'month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'Last Quarter': [dayjs().endOf('month'), dayjs().startOf('month').subtract(3, 'month')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')],
	 'This Financial Year': [dayjs().startOf('Year').add(3, 'month'), dayjs().endOf('Year').add(3, 'month')],
	 'Last Financial Year': [dayjs().subtract(1, 'year').subtract(8, 'month'), dayjs().startOf('Year').add(2, 'month')],
    'Custom':[dayjs(), dayjs().endOf('month')]
  };

if (selectedOption === 'Custom') {
    this.setState({
      fromdate: periodMap['Custom'][0],
      todate: periodMap['Custom'][1],
      fromdate1: periodMap['Custom'][0].format('YYYY-MM-DD'),
      todate1: periodMap['Custom'][1].format('YYYY-MM-DD'),
      fromDateEnabled: true,
      toDateEnabled: true
    });
  } else {
    this.setState({
      fromdate: periodMap[selectedOption][0],
      todate: periodMap[selectedOption][1],
      fromdate1: periodMap[selectedOption][0].format('YYYY-MM-DD'),
      todate1: periodMap[selectedOption][1].format('YYYY-MM-DD'),
      fromDateEnabled: false,
      toDateEnabled: false
    });
  }
};


  
  
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
	
 this.setState({
    todate: dayjs(dateObj),
    todate1: dateObj.getFullYear() + '-' + (dateObj.getMonth() + 1) + '-' + dateObj.getDate(),
    toDateEnabled: true
  });
 

  }
  


  render() {
 return (
	
	 <React.Fragment>
	 <div className="searchbox">

<ul>

<li>
<p>Period</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.onchangedateHandler}
  inputProps={{tabIndex: "4"}}
        > <option>This Month</option>
          <option>This Quarter</option>
          <option>This Year</option>
          <option>Last Month</option>
          <option>Last Quarter</option>
          <option>Last Year</option>
          <option>This Financial Year</option>
          <option>Last Financial Year</option>
          <option>Custom</option>
  </Select></p>


</li>

	
<li>

<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.fromDateEnabled}
      value={dayjs(this.state.fromdate)}
      className="txtbox"
      onChange={this.fromdatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={['DatePicker']}>
    <DatePicker
      disabled={!this.state.toDateEnabled}
      value={dayjs(this.state.todate)}
      className="txtbox"
      onChange={this.todatehandler}
      format="MM/DD/YYYY"
    />
  </DemoContainer>
</LocalizationProvider></p></li>
	
	
	</ul>
	</div>
	 </React.Fragment>

  )}
   }